import React from "react";

import client from "../lib/client";

export const updatePassword = async (payload) => {
  const response = await client.put("/user/profile/password", payload);
  return response;
};

export const useUpdatePassword = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [data, setData] = React.useState(null);

  const execute = async (payload) => {
    try {
      setIsLoading(true);
      const response = await updatePassword(payload);
      setData(response);
      return response;
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, data, execute };
};
